var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnections = function SvgConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connections_svg2__a",
    x1: -37.1,
    x2: 195.9,
    y1: 217.1,
    y2: 18.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__b",
    x1: -40.9,
    x2: 192.1,
    y1: 212.6,
    y2: 13.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__c",
    x1: -0.7,
    x2: 232.3,
    y1: 259.6,
    y2: 60.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__d",
    x1: 28.2,
    x2: 261.2,
    y1: 293.5,
    y2: 94.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__e",
    x1: -33.2,
    x2: 199.8,
    y1: 221.5,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__f",
    x1: -102.3,
    x2: 130.7,
    y1: 140.6,
    y2: -58.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__g",
    x1: -73.4,
    x2: 159.6,
    y1: 174.5,
    y2: -24.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__h",
    x1: -37.1,
    x2: 195.9,
    y1: 217.1,
    y2: 18.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#connections_svg2__a",
    id: "connections_svg2__i",
    x1: -37.1,
    x2: 195.9,
    y1: 217,
    y2: 18
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 37.1c-6.6 0-13.1 1.1-19.3 3.2-1.5.5-2.4 2.2-1.9 3.8s2.2 2.4 3.7 1.9c5.6-1.9 11.5-2.9 17.5-2.9 30.5 0 55.4 25.5 55.4 56.8s-24.8 56.8-55.4 56.8-55.4-25.5-55.4-56.8 9.8-37.8 26.2-48.3c1.4-.9 1.8-2.7.9-4.2-.9-1.4-2.7-1.8-4-1-8.7 5.5-15.9 13.3-21 22.4-5.2 9.4-8 20.1-8 31 0 34.7 27.5 62.9 61.3 62.9s61.3-28.2 61.3-62.9-27.5-62.9-61.3-62.9Z",
    style: {
      fill: "url(#connections_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6 46.9c.5.5 1.2.7 1.9.7s1.7-.4 2.3-1.1l19.4-24h10.3c1.2 3.9 4.8 6.7 9 6.7 5.2 0 9.5-4.4 9.5-9.7s-4.3-9.7-9.5-9.7-7.8 2.8-9 6.7h-11.7c-.9 0-1.7.4-2.3 1.1l-20.3 25.1c-1 1.3-.9 3.2.4 4.2m42.9-31.2c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 90.3c-4.2 0-7.8 2.8-9 6.7h-9.9c-1.6 0-2.9 1.3-2.9 3s1.3 3 2.9 3h9.9c1.2 3.9 4.8 6.7 9 6.7s9.5-4.4 9.5-9.7-4.3-9.7-9.5-9.7m0 13.4c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.7-3.6 3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 170.8c-4.2 0-7.8 2.8-9 6.7h-10.3l-19.4-24c-1-1.3-2.9-1.5-4.1-.4s-1.4 3-.4 4.2l20.3 25.1c.6.7 1.4 1.1 2.3 1.1h11.7c1.2 3.9 4.8 6.7 9 6.7s9.5-4.4 9.5-9.7c0-5.4-4.3-9.7-9.5-9.7Zm0 13.5c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.7-3.6 3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4 153.1c-1.2-1.1-3.1-.9-4.1.4l-19.4 24H18.6c-1.2-3.9-4.8-6.7-9-6.7-5.2 0-9.5 4.4-9.5 9.7s4.3 9.7 9.5 9.7 7.8-2.8 9-6.7h11.7c.9 0 1.7-.4 2.3-1.1l20.3-25.1c1-1.3.9-3.2-.4-4.2ZM9.5 184.3c-2 0-3.6-1.7-3.6-3.7s1.6-3.7 3.6-3.7 3.6 1.7 3.6 3.7-1.6 3.7-3.6 3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 29.2c4.2 0 7.8-2.8 9-6.7h10.3l19.4 24c.6.7 1.4 1.1 2.3 1.1s1.3-.2 1.9-.7c1.2-1.1 1.4-3 .4-4.2L32.5 17.6c-.6-.7-1.4-1.1-2.3-1.1H18.5c-1.2-3.9-4.8-6.7-9-6.7C4.3 9.7 0 14.1 0 19.4s4.3 9.7 9.5 9.7Zm0-13.5c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 109.7c4.2 0 7.8-2.8 9-6.7h9.9c1.6 0 2.9-1.3 2.9-3s-1.3-3-2.9-3h-9.9c-1.2-3.9-4.8-6.7-9-6.7S0 94.6 0 100s4.3 9.7 9.5 9.7m0-13.4c2 0 3.6 1.7 3.6 3.7s-1.6 3.7-3.6 3.7-3.6-1.7-3.6-3.7 1.6-3.7 3.6-3.7",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 54.1h-9.7c-2.8 0-5.1 2.4-5.1 5.3v6.1c-2.3.7-4.6 1.7-6.7 2.9l-4.2-4.3c-2-2.1-5.3-2.1-7.3 0l-6.9 7c-2 2.1-2 5.4 0 7.5l4.2 4.3c-1.2 2.2-2.1 4.5-2.8 6.9h-6c-2.8 0-5.1 2.4-5.1 5.3v10c0 2.9 2.3 5.3 5.1 5.3h6c.7 2.4 1.6 4.7 2.8 6.9l-4.2 4.3c-1 1-1.5 2.3-1.5 3.7S64 128 65 129l6.9 7c1 1 2.3 1.5 3.6 1.5s2.7-.5 3.6-1.5l4.2-4.3c2.1 1.2 4.4 2.2 6.7 2.9v6.1c0 2.9 2.3 5.3 5.1 5.3h9.7c2.8 0 5.1-2.4 5.1-5.3v-6.1c2.3-.7 4.6-1.7 6.7-2.9l4.2 4.3c2 2.1 5.3 2.1 7.3 0l6.9-7c1-1 1.5-2.3 1.5-3.7s-.5-2.7-1.5-3.7l-4.2-4.3c1.2-2.2 2.1-4.5 2.8-6.9h6c2.8 0 5.1-2.4 5.1-5.3v-10c0-2.9-2.3-5.3-5.1-5.3h-6c-.7-2.4-1.6-4.7-2.8-6.9l4.2-4.3c2-2.1 2-5.4 0-7.5l-6.9-7c-2-2.1-5.3-2.1-7.3 0l-4.2 4.3c-2.1-1.2-4.4-2.2-6.7-2.9v-6.1c0-2.9-2.3-5.3-5.1-5.3Zm10.7 20.6c1.2.8 2.7.6 3.7-.4l5.3-5.4 5.8 6-5.3 5.4c-1 1-1.1 2.6-.4 3.7 1.8 2.9 3.1 6.1 3.8 9.5.3 1.4 1.5 2.4 2.9 2.4h7.5v8.4h-7.5c-1.4 0-2.6 1-2.9 2.4-.7 3.4-2 6.5-3.8 9.5-.7 1.2-.6 2.7.4 3.7l5.3 5.4-5.8 6-5.3-5.4c-1-1-2.5-1.2-3.7-.4-2.8 1.9-5.9 3.2-9.2 3.9-1.3.3-2.3 1.5-2.3 2.9v7.7h-8.2v-7.7c0-1.4-1-2.6-2.3-2.9-3.3-.8-6.4-2.1-9.2-3.9-1.2-.8-2.7-.6-3.6.4l-5.3 5.4-5.8-6 5.3-5.4c1-1 1.1-2.6.4-3.7-1.8-2.9-3.1-6.1-3.8-9.5-.3-1.4-1.5-2.4-2.9-2.4h-7.5v-8.4h7.5c1.4 0 2.6-1 2.9-2.4.7-3.4 2-6.5 3.8-9.5.7-1.2.6-2.7-.4-3.7l-5.3-5.4 5.8-6 5.3 5.4c1 1 2.5 1.2 3.6.4 2.8-1.9 5.9-3.2 9.2-3.9 1.3-.3 2.3-1.5 2.3-2.9v-7.7h8.2v7.7c0 1.4 1 2.6 2.3 2.9 3.3.8 6.4 2.1 9.2 3.9",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8 77.3c-11.2.6-20.4 10.1-21 21.6-.3 6.4 2 12.7 6.5 17.3 4.2 4.3 9.8 6.7 15.7 6.7h1.1c1.6 0 2.9-1.5 2.8-3.2 0-1.7-1.5-2.9-3.1-2.9-4.7.2-9.1-1.5-12.4-4.9s-5-7.9-4.8-12.7c.4-8.5 7.2-15.4 15.4-15.9 4.7-.2 9.4 1.7 12.7 5.2 6.7 7.2 4.9 17.9-.6 23.5-1.1 1.2-1.1 3.1 0 4.3 1.2 1.2 3 1.2 4.2 0 3.9-4.1 6.3-9.7 6.6-15.4.3-6.2-1.8-12.1-6-16.5-4.5-4.8-10.7-7.4-17.2-7Z",
    style: {
      strokeWidth: 0,
      fill: "url(#connections_svg2__i)"
    }
  }));
};
export default SvgConnections;